import React, { memo } from 'react';
import { humanizeValue } from '../../utils';
import { StyledEachCell } from '../styled';

const EachCell = (props) => {
  const {
    cellData, unit,
  } = props;

  let parsedCellData = {
    humanizedNumber: '',
    humanizedUnit: '',
  };
  if (['low', 'NA'].includes(cellData)) {
    parsedCellData.humanizedNumber = cellData;
  } else if (['warmup'].includes(cellData)) {
    parsedCellData.humanizedNumber = 'warmup';
  } else {
    parsedCellData = humanizeValue(cellData, unit);
  }
  return (
    <StyledEachCell>
      {parsedCellData.humanizedNumber === 'warmup'
        ? (
          <span className="warmup-loader">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        )
        : (
          <React.Fragment>
            {`${parsedCellData.humanizedNumber} ${parsedCellData.humanizedUnit}`}
          </React.Fragment>
        )
      }
    </StyledEachCell>
  );
};

export default memo(EachCell);
